import { render, staticRenderFns } from "./WithdrawalRequests.vue?vue&type=template&id=4e6f2b53&scoped=true&"
import script from "./WithdrawalRequests.vue?vue&type=script&lang=js&"
export * from "./WithdrawalRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f2b53",
  null
  
)

export default component.exports